export { FolderRemove as default } from './FolderRemove';
